<template>

  <span>
    <v-icon icon="$help" size="small" />
    <v-tooltip activator="parent">
      <slot />
    </v-tooltip>
  </span>

</template>
